export const campaignRegionImages = {
  AU: { mobile: 'tours-campaign-5off-mobile-aud', desktop: 'tours-campaign-5off-desktop-aud' },
  NZ: { mobile: 'tours-campaign-5off-mobile-aud', desktop: 'tours-campaign-5off-desktop-aud' },
  SG: { mobile: 'tours-campaign-5off-mobile-aud', desktop: 'tours-campaign-5off-desktop-aud' },
  US: { mobile: 'tours-campaign-5off-mobile-usd', desktop: 'tours-campaign-5off-desktop-usd' },
  GB: { mobile: 'tours-campaign-5off-mobile-gbp', desktop: 'tours-campaign-5off-desktop-gbp' },
}
